module.exports = __webpack_public_path__ + "static/media/9DESA18.76ab9181.jpg";